

import React, { memo } from 'react';
import cx from 'classnames';
import { Link } from 'react-router-dom';
import LucideIcon from '../../LucideIcon';
import { ChevronRight } from 'lucide-react';
import Text from '../../Text';
import '../styles/_breadcrumbs.scss';






const renderBreadCrumbLink = (item, darkMode) =>
<Link
  className={cx(
    'breadcrumbs__breadcrumb__link',
    { 'breadcrumbs__breadcrumb__link--dark-mode': darkMode }
  )}
  to={item.url}>

    <Text placeholder noMargin darkTheme={darkMode}>{item.title}</Text>
  </Link>;


function BreadCrumbs({ items, darkMode }) {
  return (
    <ul className="breadcrumbs">
      {items.map((item, index) =>
      item.url ?

      <li key={item.url} className="breadcrumbs__breadcrumb">
              {renderBreadCrumbLink(item, Boolean(darkMode))}
              {
        index !== items.length - 1 ?

        <LucideIcon
          icon={ChevronRight}
          color={darkMode ? 'white' : 'regent'}
          size={18} /> :


        null}

            </li> :

      null
      )}
    </ul>);

}

BreadCrumbs.displayName = 'BreadCrumbs';
BreadCrumbs.defaultProps = {
  darkMode: false
};

export default memo(BreadCrumbs);